const api = {
  contact: '/api/message'
}

export default api
